const PWA_INSTALLED_KEY = "sf-pwa-installed";

/** True when opened as installed home-screen app (not a normal browser tab). */
export function isInstalledPwa() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.matchMedia("(display-mode: minimal-ui)").matches ||
    window.navigator.standalone === true
  );
}

export function markPwaInstalled() {
  try {
    localStorage.setItem(PWA_INSTALLED_KEY, "1");
  } catch {
    // ignore
  }
}

export function hasPwaInstallMarker() {
  try {
    return localStorage.getItem(PWA_INSTALLED_KEY) === "1";
  } catch {
    return false;
  }
}

/** Detect installed PWA even when the user is in a mobile browser tab. */
export async function detectPwaAlreadyInstalled() {
  if (isInstalledPwa()) {
    markPwaInstalled();
    return true;
  }

  if (hasPwaInstallMarker()) return true;

  if (typeof navigator !== "undefined" && typeof navigator.getInstalledRelatedApps === "function") {
    try {
      const related = await navigator.getInstalledRelatedApps();
      if (Array.isArray(related) && related.length > 0) {
        markPwaInstalled();
        return true;
      }
    } catch {
      // API unavailable or blocked
    }
  }

  return false;
}

export function isIosDevice() {
  return /iphone|ipad|ipod/i.test(typeof navigator !== "undefined" ? navigator.userAgent : "");
}

export function isAndroidDevice() {
  return /android/i.test(typeof navigator !== "undefined" ? navigator.userAgent : "");
}

/** Phone/tablet — excludes desktop browsers even when narrow. */
export function isMobileDevice() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  if (isInstalledPwa()) return true;
  const ua = navigator.userAgent || "";
  if (/android|iphone|ipad|ipod|mobile/i.test(ua)) return true;
  const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const narrow = window.matchMedia("(max-width: 768px)").matches;
  return coarsePointer && narrow;
}
